import AppDialog from "../../../AppDialog/AppDialog";
import JoinAction from "../../../actions/JoinAction/JoinAction";
import "./MoveToZoomDialog.css";
import Action from "../../../formElements/Action/Action";

interface MoveToZoomDialogProps {
  isOpen: boolean;
  onClose: () => void;
  lessonId: string;
  teacherName?: string;
}

export function MoveToZoomDialog({
  onClose,
  lessonId,
  isOpen,
  teacherName,
}: MoveToZoomDialogProps) {
  return (
    <AppDialog
      isValidForm={true}
      showDialog={isOpen}
      onClose={onClose}
      titleComponent={<h2>Moving Session to Zoom</h2>}
      formActions={
        <div className="form-actions">
          <Action onClick={onClose}>CANCEL</Action>
          <JoinAction
            lesson={{
              id: lessonId,
              validForJoining: true,
            }}
            type="button"
          />
        </div>
      }
      topBorder={true}
      className="move-session-dialog"
    >
      <div>
        <div className="dialog-desc">
          Your teacher {teacherName || ""} has requested to move your current session to
          Zoom to provide you with a better user experience.
        </div>
        <div>Please click ‘Join now’ to move to the new session.</div>
      </div>
    </AppDialog>
  );
}
